class StorageService {
  store(key, value) {
    localStorage.setItem(key, JSON.stringify(value));
  }

  load(key) {
    let value = localStorage.getItem(key);
    return value ? JSON.parse(value) : null;
  }

  remove(key) {
    localStorage.removeItem(key);
  }
}

export default new StorageService();